// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"128":"2c65225d","890":"b27c6e39","982":"5c98a0fe"}[chunkId] + ".js";
};